import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { mostraAlertaError, mostraAlertaOk, mostraAlertaWarning } from "../../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import Card from "../../../../componentes/contenedores/Card";
import Page from "../../../../componentes/plantilla/Page";
import { LotesInventarioEditar, LotesInventarioGuardar, LotesInventarioListar, ProductosListar } from '../../../../configuracion/apiUrls';
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";

const HomeEditarLoteInventario = () => {
    const { productId, loteId: loteProductoId, loteInventarioId } = useParams();
    const { listaInventariosTipos, listaProductos, setListaLotesInventarios,setListaProductos, ActualizarLista } = useContextEmpleado();
    const navigate = useNavigate();

    const [cargando, setCargando] = useState(true);
    const [nombreProducto, setNombreProducto] = useState('');
    const [nombreLote, setNombreLote] = useState('');
    const [cantidadLoteOriginal, setCantidadLoteOriginal] = useState(0);
    const [existenciaGeneralDelLote, setExistenciaGeneralDelLote] = useState(0);
    const [existenciaDisponibleParaAsignar, setExistenciaDisponibleParaAsignar] = useState(0);
    const [errorExistencia, setErrorExistencia] = useState(false);

    const [formData, setFormData] = useState({
        idLoteInventario: null,
        existenciaAsignada: 0,
        estado: 'Activo',
        idTipoInventario: ''
    });

    const datosPagina = {
        titulo: {
            titulo: "Asignar Lote a Inventario",
            url: "/app/admin/lotes/asignar",
            tituloUrl: "Lotes",
            nombreUrl: "inventario",
        },
    };

    useEffect(() => {
        setErrorExistencia(formData.existenciaAsignada < 0);
    }, [formData.existenciaAsignada]);

    useEffect(() => {
        if (!loteProductoId || listaProductos.length === 0) {
            return;
        }

        setCargando(true);
        try {
            const productoPrincipal = listaProductos.find(p => p.id === Number(productId));
            if (!productoPrincipal) {
                mostraAlertaError("Producto no encontrado.");
                return;
            }

            const loteEncontrado = productoPrincipal.lotes?.find(lote => lote.id === Number(loteProductoId));
            if (!loteEncontrado) {
                mostraAlertaError("Lote de producto no encontrado en la lista.");
                return;
            }

            setNombreProducto(productoPrincipal.nombre || 'N/A');
            setNombreLote(loteEncontrado.nombre_lote || 'N/A');
            setCantidadLoteOriginal(loteEncontrado.cantidad || 0);
            setExistenciaGeneralDelLote(loteEncontrado.existencia || 0);

            let inventarioLoteEncontrado = null;
            let existenciaInicialEsteLoteInventario = 0;

            if (loteInventarioId) {
                inventarioLoteEncontrado = loteEncontrado.loteinventarios?.find(li => li.id === Number(loteInventarioId));
                if (inventarioLoteEncontrado) {
                    existenciaInicialEsteLoteInventario = inventarioLoteEncontrado.existencia || 0;
                } else {
                    mostraAlertaWarning("Lote Inventario específico no encontrado, inicializando para nueva asignación.");
                }
            }

            const existenciaYaAsignadaOtros = (loteEncontrado.loteinventarios || []).reduce((sum, li) => {
                return sum + (li.id === Number(loteInventarioId) ? 0 : (li.existencia || 0));
            }, 0);

            const disponibleCalculado = (loteEncontrado.existencia || 0) - existenciaYaAsignadaOtros;
            setExistenciaDisponibleParaAsignar(disponibleCalculado);

            if (inventarioLoteEncontrado) {
                setFormData({
                    idLoteInventario: inventarioLoteEncontrado.id,
                    existenciaAsignada: inventarioLoteEncontrado.existencia,
                    estado: inventarioLoteEncontrado.estado,
                    idTipoInventario: Number(inventarioLoteEncontrado.inventarioTipo?.id) || ''
                });
            } else {
                setFormData({
                    idLoteInventario: null,
                    existenciaAsignada: 0,
                    estado: 'Activo',
                    idTipoInventario: ''
                });
            }
        } catch (error) {
            mostraAlertaError("Error al cargar la información del lote.");
            console.error(error);
        } finally {
            setCargando(false);
        }
    }, [loteProductoId, productId, loteInventarioId, listaProductos, listaInventariosTipos]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? (checked ? "Activo" : "Inactivo") : (name === 'existenciaAsignada' || name === 'idTipoInventario' ? Number(value) : value)
        }));
    };

    const handleGuardar = async () => {
        if (errorExistencia) {
            mostraAlertaWarning("La cantidad a asignar no puede ser negativa.");
            return;
        }
        if (!formData.idTipoInventario) {
            mostraAlertaWarning("Debe seleccionar un tipo de inventario.");
            return;
        }

        const productoPrincipal = listaProductos.find(p => p.id === Number(productId));
        const loteEncontrado = productoPrincipal?.lotes?.find(lote => lote.id === Number(loteProductoId));

        if (!loteEncontrado) {
            mostraAlertaError("Lote no encontrado para la validación de existencia.");
            return;
        }
        const existenciaYaAsignadaOtros = (loteEncontrado.loteinventarios || []).reduce((sum, li) => {
            return sum + (li.id === formData.idLoteInventario ? 0 : (li.existencia || 0));
        }, 0);

        const existenciaTotalPermitida = (loteEncontrado.existencia || 0) - existenciaYaAsignadaOtros;

        if (formData.existenciaAsignada === 0 && existenciaTotalPermitida === 0) {
            mostraAlertaWarning("No hay existencia disponible en el lote para asignar.");
            return;
        }
        if (formData.existenciaAsignada > existenciaTotalPermitida) {
            mostraAlertaWarning(`La cantidad a asignar (${formData.existenciaAsignada}) excede la existencia total disponible para el lote (${existenciaTotalPermitida}).`);
            return;
        }
        if (formData.existenciaAsignada <= 0) {
            mostraAlertaWarning("La cantidad a asignar debe ser mayor a cero.");
            return;
        }

        const payload = {
            loteId: loteProductoId,
            existencia: formData.existenciaAsignada,
            estado: formData.estado,
            inventarioTipoId: formData.idTipoInventario
        };

        try {
            if (formData.idLoteInventario) {
                await AxiosPrivado.put(LotesInventarioEditar + formData.idLoteInventario, payload);
                mostraAlertaOk("Lote en inventario actualizado correctamente");
            } else {
                await AxiosPrivado.post(LotesInventarioGuardar, payload);
                mostraAlertaOk("Lote en inventario guardado correctamente");
            }
            ActualizarLista(LotesInventarioListar, setListaLotesInventarios); 
            ActualizarLista(ProductosListar, setListaProductos);
            navigate('/app/admin/lotes/asignar');
        } catch (error) {
            mostraAlertaError("Error al guardar el lote en inventario.");
            console.error(error);
        }
    };

    if (cargando) {
        return <Page datos={datosPagina}><Card><p className="text-center">Cargando información del lote...</p></Card></Page>;
    }

    return (
        <Page datos={datosPagina}>
            <Card titulo={formData.idLoteInventario ? `Editar Lote en Inventario: ${nombreProducto}` : `Asignar Nuevo Lote a Inventario: ${nombreProducto}`}>
                <div className="row mb-4">
                    <div className="col-lg-12">
                        <h5 className="mb-3 text-primary">Información del Lote</h5>
                        <div className="row">
                            <div className="col-md-6">
                                <dl className="row mb-0">
                                    <dt className="col-sm-5 text-muted">Producto:</dt>
                                    <dd className="col-sm-7 font-weight-bold">{nombreProducto}</dd>
                                    <dt className="col-sm-5 text-muted">Lote:</dt>
                                    <dd className="col-sm-7 font-weight-bold">{nombreLote}</dd>
                                </dl>
                            </div>
                            <div className="col-md-6">
                                <dl className="row mb-0">
                                    <dt className="col-sm-6 text-muted">Cantidad Original (Histórico):</dt>
                                    <dd className="col-sm-6"><span className="badge badge-secondary p-2">{cantidadLoteOriginal} unidades</span></dd>

                                    <dt className="col-sm-6 text-muted">Existencia General del Lote:</dt>
                                    <dd className="col-sm-6"><span className="badge badge-info p-2">{existenciaGeneralDelLote} unidades</span></dd>

                                    <dt className="col-sm-6 text-muted">Existencia Disponible:</dt>
                                    <dd className="col-sm-6"><span className="badge badge-success p-2">{existenciaDisponibleParaAsignar} unidades</span></dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>

                <hr />

                <div className="row">
                    <div className="col-lg-6 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="existenciaAsignada">Existencia a Asignar</label>
                            <input
                                type="number"
                                className={`form-control ${errorExistencia ? "is-invalid" : ""}`}
                                id="existenciaAsignada"
                                placeholder="Cantidad a asignar"
                                name="existenciaAsignada"
                                value={formData.existenciaAsignada}
                                onChange={handleInputChange}
                                min="0"
                            />
                            <span id="existencia-error" className="invalid-feedback">
                                La cantidad no puede ser negativa.
                            </span>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="idTipoInventario">Tipo de Inventario</label>
                            <select
                                id="idTipoInventario"
                                className="form-control"
                                name="idTipoInventario"
                                value={formData.idTipoInventario}
                                onChange={handleInputChange}
                            >
                                <option value="">Seleccione un tipo</option>
                                {listaInventariosTipos.map((tipo) => (
                                    <option key={tipo.id} value={tipo.id}>
                                        {tipo.nombre}
                                    </option>
                                ))}
                            </select>
                            {!formData.idTipoInventario && <div className="text-danger mt-1">Debe seleccionar un tipo de inventario.</div>}
                        </div>
                    </div>
                    <div className="col-lg-12 col-sm-12">
                        <div className="form-group">
                            <label htmlFor="estadoLoteInventario">Estado</label>
                            <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="customSwitch3"
                                    name="estado"
                                    checked={formData.estado === "Activo"}
                                    onChange={handleInputChange}
                                />
                                <label className="custom-control-label" htmlFor="customSwitch3">
                                    {formData.estado}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12 text-right">
                        <button type="button" className="btn btn-warning" onClick={handleGuardar}>
                            {formData.idLoteInventario ? 'Guardar Cambios' : 'Asignar a Inventario'}
                            <i className={`fas ${formData.idLoteInventario ? 'fa-edit' : 'fa-save'} ml-2`} />
                        </button>
                    </div>
                </div>
            </Card>
        </Page>
    );
};

export default HomeEditarLoteInventario;